import * as React from "react";
import {Box, Table, TableBody, TableCell, TableHead, TableRow, Typography, useTheme} from "@mui/material";
import ExpandableDocumentCards from "./ExpandableDocumentCards";
import DocumentsPanelHeader from "./DocumentsPanelHeader";
import useExpandableRowIds from "./useExpandableRowIds";
import {daysCellRenderer, documentNumberCellRenderer, statusCellRendererFor} from "./AccountingDocumentCells";
import {EmptyDocumentDetail} from "./DocumentsEmptyStates";

function paymentProgressBar(row) {
    return (
        <Box sx={{padding: '4px 8px 10px'}}>
            <Typography variant="body2" color="text.secondary" mb={0.75}>
                Aplicado <Box component="span" fontWeight={700} color="text.primary">{row.appliedAmount}</Box>{' '}
                de <Box component="span" fontWeight={700} color="text.primary">{row.total}</Box>{' '}
                ({Math.round(row.progressPercentage)}%) — Saldo pendiente:{' '}
                <Box component="span" fontWeight={700} color="text.primary">{row.pendingAmount}</Box>
            </Typography>
            <Box sx={{height: 8, borderRadius: '4px', backgroundColor: 'divider', overflow: 'hidden', display: 'flex'}}>
                <Box sx={{height: '100%', width: `${row.progressPercentage}%`, backgroundColor: 'success.main'}}/>
                <Box sx={{height: '100%', width: `${100 - row.progressPercentage}%`, backgroundColor: 'error.main'}}/>
            </Box>
        </Box>
    );
}

function invoiceDetail(row) {
    return (
        <Box sx={{borderTop: '1px solid', borderColor: 'divider', padding: '10px 12px 12px 40px'}}>
            {paymentProgressBar(row)}
            {!row.hasApplications && <EmptyDocumentDetail label="Sin notas de crédito ni recibos aplicados a esta factura"/>}
            {row.hasApplications && (
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Tipo</TableCell>
                            <TableCell>Nº</TableCell>
                            <TableCell>Fecha</TableCell>
                            <TableCell align="right">Importe aplicado</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {row.applications.map((application, applicationIndex) =>
                            <TableRow key={applicationIndex}>
                                <TableCell>{application.type}</TableCell>
                                <TableCell>{application.numberWithPointOfSale}</TableCell>
                                <TableCell>{application.issueDate}</TableCell>
                                <TableCell align="right">{application.appliedAmount}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
}

function InvoicesPanel({rows, columns, description}) {
    const theme = useTheme();
    const {expandedRowIds, toggleRow, expandAllOf, collapseAll} = useExpandableRowIds();
    const allRowsAreExpanded = rows.length > 0 && expandedRowIds.size === rows.length;

    const toggleAllRows = () => {
        if (allRowsAreExpanded) {
            collapseAll();
        } else {
            expandAllOf(rows.map(row => row.id));
        }
    };

    const columnsRenderer = {
        numberWithPointOfSale: documentNumberCellRenderer,
        statusLabel: statusCellRendererFor(theme),
        daysLabel: daysCellRenderer,
    };

    return (
        <div>
            <DocumentsPanelHeader description={description} allRowsAreExpanded={allRowsAreExpanded} onToggleAll={toggleAllRows}/>
            <ExpandableDocumentCards rows={rows} columns={columns} columnsRenderer={columnsRenderer} renderDetail={invoiceDetail}
                                     emptyLabel="No hay facturas para mostrar" expandedRowIds={expandedRowIds} onToggleRow={toggleRow}/>
        </div>
    );
}

export default InvoicesPanel;
